/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_BodyInputs */

const en_auth_ground_body = /** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan the work, track the hours, bill the client and share it all in their own portal.`)
};

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const ar_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const he_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const ur_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const es_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const fr_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const de_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const pt_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const hi_auth_ground_body = en_auth_ground_body;

/** @type {(inputs: Auth_Ground_BodyInputs) => LocalizedString} */
const bn_auth_ground_body = en_auth_ground_body;

/**
* | output |
* | --- |
* | "Plan the work, track the hours, bill the client and share it all in their own portal." |
*
* @param {Auth_Ground_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_body = /** @type {((inputs?: Auth_Ground_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_body(inputs)
	if (locale === "he") return he_auth_ground_body(inputs)
	if (locale === "ur") return ur_auth_ground_body(inputs)
	if (locale === "es") return es_auth_ground_body(inputs)
	if (locale === "fr") return fr_auth_ground_body(inputs)
	if (locale === "de") return de_auth_ground_body(inputs)
	if (locale === "pt") return pt_auth_ground_body(inputs)
	if (locale === "hi") return hi_auth_ground_body(inputs)
	if (locale === "bn") return bn_auth_ground_body(inputs)
	return /** @type {LocalizedString} */ ("Plan the work, track the hours, bill the client and share it all in their own portal.")
});